import React, { useState } from "react";
import toast from "react-hot-toast";
import classNames from "classnames";
import { Sendum, Components, Services, Assets, Utils } from "@sendum/core";

import classes from "./Landing.module.scss";

interface IProps {
	className?: string;
	redirectPath: string;
}

export const Landing = (props: IProps): JSX.Element => {
	const [orderId, setOrderId] = useState<string>("");
	const [serialNumber, setSerialNumber] = useState<string>("");
	const [isLoading, setLoading] = useState<boolean>(false);
	const [state, setState] = useState<"" | "success" | "error_shipment" | "error_dsn">("");

	const orderIdInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
		event.preventDefault();
		setOrderId(event.target.value || "");
	};

	const serialNumberInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
		event.preventDefault();
		setSerialNumber(event.target.value || "");
	};

	const goButtonOnClickHandler = (): void => {
		setLoading(true);
		const trimmedOrderId = orderId.trim();
		const trimmedSerialNumber = serialNumber.trim();

		setOrderId(trimmedOrderId);
		setSerialNumber(trimmedSerialNumber);

		Services.API.WidgetsApi.getShipmentByOrderId(trimmedOrderId)
			.then(shipment => {
				setLoading(false);
				const cargo = shipment.cargoes.find(c => c.containerId === trimmedSerialNumber);
				if (trimmedSerialNumber && (!cargo || !cargo.devices[0])) {
					setState("error_dsn");
					setTimeout(() => {
						setState("");
					}, Utils.time.HIDE_ERROR_TIMEOUT);

					return;
				}

				setState("success");
				setTimeout(() => {
					setState("");
					const queryString = cargo ? `?deviceId=${cargo?.devices[0]}` : "";
					Sendum.getBrowserHistory().push(`${props.redirectPath}/${trimmedOrderId}${queryString}`);
				}, Utils.time.HIDE_SUCCESS_TIMEOUT);
			})
			.catch(error => {
				const brand = window.location.hostname.split('.')[0];
				let origin = window.location.origin;
				switch (brand) {
					case 'marken':
					case 'marken-v3': {
						origin = "https://marken-v3.sendum.com";
						break;
					}
					case 'marken-dev':
					case 'marken-v3-dev':
					case 'marken-test':
					case 'marken-local': {
						origin = "https://marken-v3-dev.sendum.com";
						break;
					}
					case 'cryolab':
					case 'cryolab-v3':
					{
						origin = "https://cryolab-v3.sendum.com";
						break;
					}
					case 'cryolab-dev':
					case 'cryolab-v3-dev':
					case 'cryolab-test':
					case 'cryolab-local': {
						origin = "https://cryolab-v3-dev.sendum.com";
						break;
					}
					default: {}
				}
				Services.API.VoyagerApi.getVoyagerRedirectUrl(trimmedOrderId, origin)
					.then(({url}) => {
						setLoading(false);
						console.log(url);

						setState("success");
						setTimeout(() => {
							setState("");

							Sendum.getBrowserHistory().push(`${url}`);
						}, Utils.time.HIDE_SUCCESS_TIMEOUT);
					})
					.catch(error => {
						if (error instanceof Error) {
							toast.error(error.message);
						}
						setState("error_shipment");
						setLoading(false);
						setTimeout(() => {
							setState("");
						}, Utils.time.HIDE_ERROR_TIMEOUT);
					});
				// if (error instanceof Error) {
				// 	toast.error(error.message);
				// }
				// setState("error_shipment");
				// setLoading(false);
				// setTimeout(() => {
				// 	setState("");
				// }, Utils.time.HIDE_ERROR_TIMEOUT);
			});
	};

	return (
		<div className={classNames(classes.landing, props.className)}>
			<Components.CustomToaster />
			{isLoading && (<Components.Loader className={classes.landing__loader} />)}
			{state === "success" && (<div className={classes.landing__stateSuccess}><img className={classes.landing__stateSuccessImg} src={Assets.Go} alt={""} /></div>)}
			{state === "error_shipment" && (<div className={classes.landing__stateError}>
				<img className={classes.landing__stateErrorImg} src={Assets.NoGo} alt={""} />
				<div className={classes.landing__stateText}>HAWB {orderId} does not matched</div>
				<div className={classes.landing__stateText}>Please try again</div>
			</div>)}
			{state === "error_dsn" && (<div className={classes.landing__stateError}>
				<img className={classes.landing__stateErrorImg} src={Assets.NoGo} alt={""} />
				<div className={classes.landing__stateText}>Dewar Serial Number {serialNumber} does not matched or container does not contains device(s)</div>
				<div className={classes.landing__stateText}>Please try again</div>
			</div>)}
			<div className={classes.landing__column}>
				<Components.Label text={"HAWB"}>
					<Components.Input
						type={"text"}
						value={orderId}
						placeholder={"HAWB"}
						name={"orderId"}
						autoComplete={"on"}
						onChange={orderIdInputOnChangeHandler}
					/>
				</Components.Label>
				<Components.Label text={"Dewar Serial Number"}>
					<Components.Input
						type={"text"}
						value={serialNumber}
						placeholder={"Dewar Serial Number"}
						name={"serialNumber"}
						autoComplete={"on"}
						onChange={serialNumberInputOnChangeHandler}
					/>
				</Components.Label>
				<Components.Button className={classes.landing__button} title={"Go"} onClick={goButtonOnClickHandler} />
			</div>
		</div>
	);
};
